<template>
  <main class="engine-adjustment-container">
    <h2>{{ translate("engine_adjustment") }}</h2>

    <section class="container">
      <div class="two-col-info">
        <div class="element">
          <h3>Obecny silnik</h3>
          <p class="selected-engine-short">
            {{ previousEngine.manufacturer }}
            {{ previousEngine.designation }}
          </p>
        </div>
        <div class="element">
          <h3>Wybrany silnik</h3>
          <p class="selected-engine-short" v-if="selectedEngine">
            {{ selectedEngine.manufacturer }}
            {{ selectedEngine.designation }}
          </p>
          <p class="selected-engine-short default-engine" v-else>
            {{ previousEngine.manufacturer }}
            {{ previousEngine.designation }}
          </p>

        </div>
      </div>
      <hr>
      <div class="comparison-container">
        <h3 style="text-align: center">{{ translate("comparition") }}</h3>
        <div v-for="column in columns" class="comparison-row" v-if="!column.non_comparable">
          <p class="title">
                        <span v-if="!column.translation">
                            {{ translate(column.title) }}
                        </span>
            <span v-else>
                            {{ translate(column.translation) }}
                        </span>
            <span v-if="column.suffix" v-html="' '+column.suffix"/>
          </p>
          <div class="comparator">
            <p class="value right">{{ previousEngine[column.title] }}</p>
            <p class="is_this_loss" v-show="selectedEngine"
               :class="isBalanceProfitable(balance(column, selectedEngine, previousEngine))?'profit':'loss'">
              {{ getSign(column, balance(column, selectedEngine, previousEngine)) }}{{ balance(column, selectedEngine, previousEngine) }}
            </p>
            <p class="value left">{{ selectedEngine[column.title] }}</p>
          </div>
          <p class="title">
                        <span v-if="!column.translation">
                            {{ translate(column.title) }}
                        </span>
            <span v-else>
                            {{ translate(column.translation) }}
                        </span>
            <span v-if="column.suffix" v-html="' '+column.suffix"/>
          </p>
        </div>
      </div>

      <hr>
      <div class="navigation">
        <router-link to="/" class="back-btn circle-btn">
        </router-link>
        <button class="save-button" @click="saveEngine()" v-if="isEditable">
          <template>
            {{ translate("save_engine") }}
          </template>
        </button>
      </div>
    </section>
  
    <!-- NVS-191 - ukrycie search-boxa ogólnego -->
    <div class="filter-container filter" v-if="false">
      <div class="container active">
        <span class="icon-loop"/>
        <input type="text" :placeholder="translate('filter_engines')" @input="filter($event.target.value)"/>
      </div>
    </div>

    <section class="container engines-list table">
      <div class="display-offers-container">
        <div class="fans-offer-container">
          <div class="table-row no-hover table-header-row">
            <div class="table-header" :class="(column.style)?column.style:[]" v-for="column in columns">
              <div :class="{'sortable':column.sortable}" @click="sortColumn(column.title, column)">
                <span v-if="column.translatable===false">{{ column.name }}</span>
                <span v-else-if="column.translation" v-html="translate(column.translation)"/>
                <span v-else v-html="translate(column.title)"/>
                <span v-if="column.suffix" v-html="' '+column.suffix"/>
                <span v-if="column.sortable" class="sort-order"
                      :class="{'active' : sorting[column.title]?sorting[column.title].current:false}">
                                        {{ (sorting[column.title]) ? (sorting[column.title].order) ? 'ASC' : 'DESC' : '' }}
                                    </span>
              </div>
              <!-- NVS-191 - dodanie filtrów do każdej kolumny -->
              <div class="search-box">
                <span class="icon-loop"/>
                <input type="text" :placeholder="translate('filter_engines')" @input="filterColumn($event.target.value, column)" />
              </div>
            </div>
          </div>
          <div class="table-row" v-for="engine in engines" @click="selectEngine(engine)"
               :class="{'current': engine.id === selectedEngine.id}">
            <div class="table-content" v-for="column in columns" :class="(column.style)?column.style:[]">
              <div class="full-height" v-if="!column.price">
                {{ engine[column.title] }}
              </div>
              <div class="full-height" v-else>
                {{ $priceController.convertWithThousandSeparator(engine[column.title].toFixed(2)) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

  import debounce from "lodash.debounce";
  import Vue from "vue";

  export default {
    name: "EngineAdjustment",
    methods: {
      translate(code) {
        let arg = {
          type: 'translate',
          code: code,
          out: ""
        }

        this.$store.commit(arg);

        if (this.strippedUnits.indexOf(code) !== -1) {
          arg.out = arg.out.split("[")[0];
        }

        return arg.out;

      },
      balance(column, a, b) {
        if (!b || !a) {
          return 0;
        }
        if (column.integer) {
          return (parseFloat(a[column.title]) - parseFloat(b[column.title])).toFixed(2);
        } else {
          if (a[column.title] === b[column.title]) {
            return "=";
          } else {
            return "~";
          }
        }
      },
      isBalanceProfitable(balance) {
        if (balance === "=") return true;
        if (balance === "~") return false;
        if (balance >= 0) return true;
        if (balance < 0) return false;
      },
      getSign(column, balance) {
        if (column.integer) {
          if (balance > 0) return "+";
        } else {
          return "";
        }
      },
      sortColumn(name, column) {
        if (this.lastSortedColumnCode === name) {
          this.sorting[name].order = !this.sorting[name].order;
        }

        this.engines.sort((a, b) => {
          if (column.integer) {
            a[name] = parseFloat(a[name]);
            b[name] = parseFloat(b[name]);
          }

          if (this.sorting[name].order) {
            return a[name] > b[name] ? 1 : -1;
          } else {
            return b[name] > a[name] ? 1 : -1;
          }
        })

        this.lastSortedColumnCode = name;

        for (let field in this.sorting) {
          if (this.sorting.hasOwnProperty(field)) {
            this.sorting[field].current = false;
          }
        }
        this.sorting[name].current = true;
      },

      filter: debounce(function (filter) {
        if (filter === '') {
          this.engines = this.enginesConst;
          return;
        }

        filter = filter.toLowerCase();
        this.engines = this.enginesConst.filter(x =>
          Object.values(x).join(" ").toLowerCase().includes(filter.replace(",", "."))
        )
      }, 500),

      filterColumn: debounce(function (filter, column) {
        const columnIndex = this.columns.findIndex(col => col.title === column.title);
        this.columns[columnIndex].filter = filter.toLowerCase().replace(",", ".");
        this.engines = this.enginesConst.filter(x => Object.keys(x).every(key => {
          const col = this.columns.find(col => col.title === key);
          if (!col || col.filter === '') return true;
          return x[key].toString().toLowerCase().includes(this.columns.find(col => col.title === key).filter);
        }))
      }, 500),

      saveEngine() {
        if (this.selectedEngine) {
          let fanObj = this.$store.state.activeFun;
          let engine_rpm = parseFloat(this.$store.state.appMeasurementsList[fanObj.selectedFanData['id_measurement']]["engine_rpm"]);
          let frequency = parseFloat(this.$fanObjParamsManager.getNetwork_frequency(this.$store));

          fanObj.params['installed_power'] = parseFloat(this.selectedEngine["power_" + frequency + "_hz"]);
          fanObj.data['maximum_engine_power'] = this.$calculator.calcMaximumEnginePower(engine_rpm, fanObj.params['installed_power'], this.selectedEngine["efficiency_3_4"]);
          fanObj.params['engine_efficiency'] = this.selectedEngine["efficiency_3_4"];
          fanObj.engine = this.selectedEngine;

          let countOfFans = this.$store.state.workPointParameters.elements.number_of_fans.value;
          fanObj.params['installed_power'] = fanObj.params['installed_power'];
          let extensionInfo = this.$calculator.getExtensionInfo(this.$store);

          this.$fanObjParamsManager.fill_price(fanObj.selectedFanData, null, this.$store, fanObj, extensionInfo, countOfFans);

          // NVS-188 - póki co wyłączam te warunki bo powodują rozjeżdżanie się wykresów
          // let pressureType = this.$fanObjParamsManager.getPressureType(this.$store);
          // let performanceTmp = this.$store.state.selectedWorkPoint.workPointPerformance / countOfFans;
          // let performanceHourTmp = performanceTmp * 3600;
          // let measurement = this.$calculator.MakeMeasurement(this.$store, fanObj.selectedFanData.id_measurement, frequency, pressureType, performanceTmp, performanceHourTmp);

          // let workPointPerformance = parseFloat(Math.min(measurement.graphsObj.fan.lines.PowerOnShaftWithMaterial.getDataByY(fanObj.data.maximum_engine_power, measurement.data.range_min, measurement.data.range_max)).toFixed(3));
          // let workPointTotalPressure = measurement.graphsObj.fan.lines.TotalPressure.fun(workPointPerformance);

          // if ((((isNaN(measurement.graphsObj.workPointResult['PowerOnShaftWithMaterial']) ||
          //             (fanObj.selectedFanData.motor_power !== "constant" && (measurement.graphsObj.workPointResult['PowerOnShaftWithMaterial'] / countOfFans) > fanObj.data.maximum_engine_power))
          //     ) ||
          //     (isNaN(measurement.graphsObj.data["workPointAmountUnit"]) || isNaN(measurement.graphsObj.workPointResult["Performance"]) ||
          //         (Number.parse(measurement.graphsObj.data['workPointAmount']) / 3.6 / Number.parse((measurement.graphsObj.workPointResult["Performance"].oryginal / countOfFans))) > parseFloat(fanObj.selectedFanData.max_density)
          //     ))
          // ) {
          //   if (this.$store.state.selectedWorkPoint && this.$store.state.selectedWorkPoint.workPointPerformance > workPointPerformance) {
          //     Vue.set(this.$store.state.selectedWorkPoint, 'workPointPressure', workPointTotalPressure);
          //     Vue.set(this.$store.state.selectedWorkPoint, 'workPointPerformance', workPointPerformance);
          //     Vue.set(this.$store.state.selectedWorkPoint, 'workPointPerformanceHour', workPointPerformance * 3600);
          //   }
          // }
          // NVS-205 wyłączam bo nie jest już potrzebne
          // NVS-101
          // this.$store.state.reloadFan = true;
        }
        this.$router.push('/');
      },

      loadStripUnitsColumns() {
        for (let column in this.columns) {
          if (this.columns[column].strip_unit) {
            this.strippedUnits.push(this.columns[column].translation);
          }
        }
      },

      loadDefaultSorting() {
        this.columns.forEach((el) => {
          if (el.sortable) {
            this.sorting[el.title] = {
              order: true,
              current: false
            }
          }
        });
      },

      loadEngines() {
        this.engines = this.$store.state.enginesList;
        this.enginesConst = this.$store.state.enginesList;
      },

      getEnginePrice(id) {
        let enginePrice = this.$store.state.pricesList.find(x => x.id == id);
        if (enginePrice && enginePrice.constant) {
          return enginePrice.constant;
        } else {
          return 0;
        }
      },

      updateEnginesPrices() {
        this.previousEngine['price'] = parseFloat(this.getEnginePrice(this.previousEngine.id_price));

        for (let engine in this.enginesConst) {
          this.enginesConst[engine]["price"] = parseFloat(this.getEnginePrice(this.enginesConst[engine].id_price));
        }
        this.engines = this.enginesConst;
      },

      selectEngine(engine) {
        this.selectedEngine = engine;
      }
    },
    data() {
      return {
        engines: [],
        enginesConst: [],
        phrase: '',
        sorting: {},
        lastSortedColumnCode: '',
        previousEngine: {},
        strippedUnits: [],
        selectedEngine: false,
        columns: [
          {
            title: 'manufacturer',
            translation: 'producer',
            sortable: true,
            filter: '',
          },//1
          {
            title: 'engine_type',
            translation: 'engine_type',
            sortable: true,
            filter: '',
          },//2
          {
            title: 'efficiency_class',
            translation: 'efficiency_class',
            sortable: true,
            filter: '',
          },//3
          {
            title: 'designation',
            translation: 'motor_designation',
            sortable: true,
            filter: '',
          },//11
          {
            title: 'speed',
            translation: 'engine_speed',
            suffix: '[1/min]',
            sortable: true,
            filter: '',
          },//4
          {
            title: 'power_designation',
            translation: 'rated_power',
            suffix: '[kW]',
            integer: true,
            sortable: true,
            filter: '',
          },//5
          {
            title: 'power_50_hz',
            sortable: true,
            filter: '',
            translation: 'gp_power',
            suffix: '[kW] (50 Hz)',
            strip_unit: true,
            integer: true,
          },//6
          {
            title: 'power_60_hz',
            sortable: true,
            filter: '',
            translation: 'gp_power',
            suffix: '[kW] (60 Hz)',
            strip_unit: true,
            integer: true,
          },//7
          {
            title: 'price',
            sortable: true,
            filter: '',
            translation: 'price',
            suffix: "(BEZ RABATU) [EUR]",
            price: true,
            integer: true,
          },//8
          {
            title: 'voltage_50_hz',
            translation: 'current',
            suffix: '[V] (50 Hz)',
            sortable: true,
            filter: '',
          },//9
          {
            title: 'voltage_60_hz',
            translation: 'current',
            suffix: '[V] (60 Hz)',
            sortable: true,
            filter: '',
          },//10
          {
            title: 'current_phase',
            sortable: true,
            filter: '',
            integer: true,
            translation: 'phase_count',
            style: [
              'width-col-150'
            ]
          },//12
          {
            title: 'current_type',
            translation: 'current_type',
            sortable: true,
            filter: '',
            style: [
              'width-col-150'
            ]
          },//13
          {
            title: 'speed_50_hz',
            sortable: true,
            filter: '',
            translation: 'speed',
            suffix: '[1/min] (50 Hz)',
            integer: true,
          },//14
          {
            title: 'speed_60_hz',
            sortable: true,
            filter: '',
            translation: 'speed',
            suffix: '[1/min] (60 Hz)',
            integer: true,
          },//15
          {
            title: 'efficiency_1_1',
            sortable: true,
            filter: '',
            translation: 'gp_efficiency',
            strip_unit: true,
            suffix: '1/1',
            integer: true,
          },//16
          {
            title: 'efficiency_3_4',
            sortable: true,
            filter: '',
            translation: 'gp_efficiency',
            strip_unit: true,
            suffix: '3/4',
            integer: true,
          },//16
          {
            title: 'efficiency_1_2',
            sortable: true,
            filter: '',
            translation: 'gp_efficiency',
            strip_unit: true,
            suffix: '1/2',
            integer: true,
          },//16
          {
            title: 'amperage',
            sortable: true,
            filter: '',
            translation: 'amperage',
            suffix: '[A] (400V)',
            integer: true,
            non_comparable: true
          },
          {
            title: 'start_up_intensity',
            sortable: true,
            filter: '',
            translation: 'start_up_amperage',
            suffix: '[A]',
            integer: true,
            non_comparable: true
          },
          {
            title: 'power_factor',
            sortable: true,
            filter: '',
            translation: 'power_factor',
            suffix: "(PF)",
            integer: true,
            non_comparable: true
          },
          {
            title: 'torque_tn',
            sortable: true,
            filter: '',
            translation: 'momentum',
            suffix: "T<sub>N</sub>",
            integer: true,
            non_comparable: true
          },
          {
            title: 'torque_ts_tn',
            sortable: true,
            filter: '',
            translation: 'momentum',
            suffix: "T<sub>S</sub> / T<sub>N</sub>",
            integer: true,
            non_comparable: true
          },
          {
            title: 'torque_tm_tn',
            sortable: true,
            filter: '',
            translation: 'momentum',
            suffix: "T<sub>M</sub> / T<sub>N</sub>",
            integer: true,
            non_comparable: true
          },
          {
            title: 'moment_of_inertia',
            sortable: true,
            filter: '',
            translation: 'moment_of_inertia',
            integer: true,
            non_comparable: true
          },
          {
            title: 'mechanical_altitude',
            sortable: true,
            filter: '',
            translation: 'mechanical_altitude',
            integer: true,
            non_comparable: true
          },
          {
            title: 'min_temperature',
            sortable: true,
            filter: '',
            translation: 'Min. Temp.',
            suffix: '[&deg;C]',
            integer: true
          },
          {
            title: 'max_temperature',
            sortable: true,
            filter: '',
            translation: 'Max. Temp',
            suffix: '[&deg;C]',
            integer: true
          },
          {
            title: 'weight',
            sortable: true,
            filter: '',
            suffix: '[kg]',
            integer: true,
            style: [
              'width-col-150'
            ]
          },//17
          {
            title: 'comment',
            sortable: true,
            filter: '',
            non_comparable: true,
            style: [
              'width-col-150'
            ]
          },
        ]
      }
    },

    beforeMount() {
      if (this.$store.getters.getUserRole !== 'admin') {
        this.$router.replace('/');
      }
    },

    mounted() {
      this.$forceUpdate();
      this.loadEngines();
      this.updateEnginesPrices();
      this.loadDefaultSorting();
    },

    created() {
      this.loadStripUnitsColumns();
      this.previousEngine = JSON.parse(JSON.stringify(this.$store.state.activeFun.engine));
    },

    computed: {
      isEditable() {
        return this.$store.getters.isOfferEditable;
      }
    }
  }
</script>
